import axios from '../config/axiosConfig';
import { API_BASE_URL } from '../config/api';

const API_URL = `${API_BASE_URL}/auth`;

const authService = {
  getToken: () => {
    return localStorage.getItem('authToken');
  },

  login: async (email, password) => {
    const response = await axios.post(`${API_URL}/login/`, { email, password });
    return response.data;
  },

  logout: async (token) => {
    return axios.post(`${API_URL}/logout/`, {}, {
      headers: { Authorization: `Token ${token}` }
    });
  },

  confirmEmail: async (token) => {
    const response = await axios.post(`${API_URL}/confirm-email/`, { token });
    return response.data;
  },

  setPassword: async (token, password) => {
    const response = await axios.post(`${API_URL}/set-password/`, { token, password });
    return response.data;
  },

  resetPassword: async (email) => {
    const response = await axios.post(`${API_URL}/password-reset/`, { email });
    return response.data;
  },

  getCurrentUser: async (token) => {
    const response = await axios.get(`${API_URL}/me/`, {
      headers: { Authorization: `Token ${token}` }
    });
    return response.data;
  },

  updatePreferences: async (token, payload) => {
    const response = await axios.patch(`${API_URL}/me/`, payload, {
      headers: { Authorization: `Token ${token}` }
    });
    return response.data;
  },
};

export default authService;
